// 优惠券板块接口api
import request from '@/utils/request'

// 获取优惠券板块列表
export const getCouponTabPage = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantCoupon/pageTab',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 获取领券中心当前用户可见的优惠券
export const getCouponCenterPage = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantCouponCenter/page',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 领取优惠券
export const receiveCoupon = couponId => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantCouponCenter/claim',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data: { couponId }
	})
}

// 获取当前用户的券包
export const getMyCouponPage = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantCouponCenter/myPage',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}
